/* ============================================================
   Maison Atelier Premium — wishlist.js
   Wishlist front-end via localStorage (nessun account richiesto)
   ============================================================ */
(function () {
  'use strict';
  var strings = (window.theme && window.theme.strings) || {};
  var memory = [];
  var storageUnavailable = false;

  function normalize(list) {
    if (!Array.isArray(list)) return [];
    return list.filter(function (handle, index) {
      return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(handle) && list.indexOf(handle) === index;
    });
  }

  var Wishlist = {
    key: 'sav_wishlist',
    get: function () {
      if (!storageUnavailable) {
        try { memory = normalize(JSON.parse(localStorage.getItem(this.key))); } catch (e) { storageUnavailable = true; }
      }
      return memory.slice();
    },
    set: function (list) {
      memory = normalize(list);
      try { localStorage.setItem(this.key, JSON.stringify(memory)); } catch (e) { storageUnavailable = true; }
    },
    has: function (handle) { return this.get().indexOf(handle) !== -1; },
    toggle: function (handle) {
      if (!normalize([handle]).length) return false;
      var list = this.get();
      var idx = list.indexOf(handle);
      if (idx === -1) list.push(handle); else list.splice(idx, 1);
      this.set(list);
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length, handle: handle, added: idx === -1 } }));
      return idx === -1;
    },
    syncButtons: function (root) {
      var self = this;
      var handles = self.get();
      (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var active = handles.indexOf(btn.getAttribute('data-wishlist-toggle')) !== -1;
        btn.setAttribute('aria-pressed', String(active));
        btn.setAttribute('aria-label', active ? (strings.wishlistRemove || '') : (strings.wishlistAdd || ''));
      });
    }
  };
  window.theme = window.theme || {};
  window.theme.Wishlist = Wishlist;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var active = Wishlist.toggle(btn.getAttribute('data-wishlist-toggle'));
    btn.setAttribute('aria-pressed', String(active));
    btn.setAttribute('aria-label', active ? (strings.wishlistRemove || '') : (strings.wishlistAdd || ''));
  });

  function updateCount() {
    var n = Wishlist.get().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  document.addEventListener('wishlist:updated', function () { Wishlist.syncButtons(); updateCount(); });
  window.addEventListener('storage', function (event) {
    if (event.key !== Wishlist.key && event.key !== null) return;
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: Wishlist.get().length } }));
  });
  document.addEventListener('cards:rendered', function (e) {
    Wishlist.syncButtons(e.detail && e.detail.root ? e.detail.root : document);
  });

  Wishlist.syncButtons();
  updateCount();
})();
